__turbopack_context__.v({
  "collectionDropdown": "header-module__xL6yza__collectionDropdown",
  "collectionPanel": "header-module__xL6yza__collectionPanel",
  "customJustifyCenter": "header-module__xL6yza__customJustifyCenter",
  "customSwiper": "header-module__xL6yza__customSwiper",
  "dropdown": "header-module__xL6yza__dropdown",
  "dropdownContainer": "header-module__xL6yza__dropdownContainer",
  "dropdownContent": "header-module__xL6yza__dropdownContent",
  "fadeIn": "header-module__xL6yza__fadeIn",
  "navLink": "header-module__xL6yza__navLink",
  "searchDropdown": "header-module__xL6yza__searchDropdown",
  "searchDropdownContainer": "header-module__xL6yza__searchDropdownContainer",
  "slickSlide": "header-module__xL6yza__slickSlide",
  "slideDown": "header-module__xL6yza__slideDown",
  "slideDowns": "header-module__xL6yza__slideDowns",
  "slideIn": "header-module__xL6yza__slideIn",
  "slideIns": "header-module__xL6yza__slideIns",
  "visible": "header-module__xL6yza__visible",
  "visibles": "header-module__xL6yza__visibles",
});
